import { motion } from 'motion/react';
import React from 'react';
import { useTheme } from '../context/ThemeContext';

export const Background = () => {
  const { mode, preset } = useTheme();
  const isZen = preset === 'zen';

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none bg-background transition-colors duration-500">
      {/* Gradient Base */}
      <div className={`absolute inset-0 transition-opacity duration-500 ${mode === 'dark' ? 'opacity-100' : 'opacity-20'}`}>
         <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/10 via-background to-background" />
      </div>
      
      {/* Space Effects - Only if NOT Zen */}
      {!isZen && (
        <>
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/10 blur-[120px] rounded-full mix-blend-screen animate-pulse" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-white/5 blur-[120px] rounded-full mix-blend-screen animate-pulse delay-1000" />
          
          <div 
            className="absolute inset-0 opacity-[0.15]"
            style={{
              backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
              backgroundSize: '4rem 4rem',
              transform: 'perspective(1000px) rotateX(60deg) translateY(-100px) scale(2)',
              maskImage: 'linear-gradient(to bottom, transparent, black 40%, black 80%, transparent)'
            }}
          />

          {[...Array(20)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute rounded-full bg-primary"
              initial={{
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                opacity: Math.random() * 0.5 + 0.2,
                scale: Math.random() * 0.5 + 0.5,
              }}
              animate={{
                y: [null, Math.random() * -100],
                opacity: [null, 0],
              }}
              transition={{
                duration: Math.random() * 10 + 10,
                repeat: Infinity,
                ease: "linear",
              }}
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
              }}
            />
          ))}
        </>
      )}

      {/* Zen Specific Subtle Texture */}
      {isZen && (
        <div className="absolute inset-0 opacity-[0.03]" 
             style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }} 
        />
      )}
    </div>
  );
};
